export default function Usdt({ size = 45 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="usdt"
      x={0}
      y={0}
      enableBackground="new 0 0 500 500"
      width={size}
      height={size}
      viewBox="0 0 500 500"
    >
      <path
        d="M91.5 34.7.4 226.2c-.7 1.5-.4 3.2.8 4.3l246.2 235.9c1.5 1.4 3.7 1.4 5.2 0l246.2-235.9c1.2-1.1 1.5-2.9.8-4.3L408.5 34.7c-.6-1.3-1.9-2.2-3.4-2.2H94.9c-1.4 0-2.7.8-3.4 2.2z"
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#50af95',
        }}
      />
      <path
        d="M281.6 245.8c-1.8.1-10.9.7-31.3.7-16.2 0-27.7-.5-31.7-.7-62.6-2.8-109.4-13.7-109.4-26.7 0-13.1 46.7-23.9 109.4-26.7V235c4.1.3 15.8 1 32 1 19.4 0 29.2-.8 30.9-1v-42.6c62.5 2.8 109.1 13.7 109.1 26.7s-46.5 23.9-109 26.7zm0-57.8v-38.1h87.2V91.8H131.4v58.1h87.2V188c-70.9 3.3-124.2 17.3-124.2 34.1s53.3 30.8 124.2 34.1v122.1h63V256.2c70.7-3.3 123.9-17.3 123.9-34.1s-53.1-30.8-123.9-34.1zm0 0z"
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#fff',
        }}
      />
    </svg>
  )
}
